import type { Args as BaseArgs, OptionRaw, OptionTransformed } from 'webapp/components/form/select';
import FormSelectComponent from 'webapp/components/form/select';

type Type = string | number;

export type ActionOption = OptionTransformed<Type> & { position: string };

type Args = BaseArgs & {
	actionOptions?: ActionOption[];
};

export default class FormSelectWithActionComponent extends FormSelectComponent<Args> {
	override _parseOptions(optionsRaw: OptionRaw<Type>[]): OptionTransformed<Type>[] {
		const options = super._parseOptions(optionsRaw);

		(this.args.actionOptions || []).forEach((actionOption) => {
			const method = actionOption.position === 'bottom' ? 'push' : 'unshift';
			options[method](actionOption);
		});

		return options;
	}
}
